import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import './Navbar.css';
import { useDispatch } from 'react-redux';
import { logout } from '../../redux/actions/authActions';
import { SHOW_METRICS } from '../../helpers/features';

const Navbar = (props) => {
  const { token, email } = props;
  const { isDarkMode, toggleTheme } = useTheme();
  const dispatch = useDispatch();
  const history = useNavigate();

  const handleKeycloakLogout = () => {
    dispatch(logout(history))
  }

  return (
    <div className="container-fluid navbar-container">
      <div className="row align-items-center gy-2">
        <div className="col-7 col-md-4 order-1 navbar-branding">
          <h1>Portal Empresarial</h1>
          {token && <p>Iniciaste con: {email}</p>}
        </div>
        <div className="col-12 col-md-4 order-3 order-md-2 d-flex justify-content-center">
        {
          token && (
            <nav className="navbar-links">
              <NavLink
                to="/"
                className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
              >
                Inicio
              </NavLink>
{/*               <NavLink
                to="/systems"
                className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
              >
                Sistemas
              </NavLink> */}
              {SHOW_METRICS && (
                <NavLink
                  to="/dashboard"
                  className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
                >
                  Métricas
                </NavLink>
              )}
            </nav>
          )
          }
        </div>
        <div className="col-5 col-md-4 order-2 order-md-3 d-flex justify-content-end align-items-center">
          <button
              className="theme-toggle me-2 me-md-4"
              onClick={toggleTheme}
              aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
            >
              {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
          </button>
          {token && (<button type="button" className='btn btn-danger' onClick={handleKeycloakLogout}>Logout</button>)}
        </div>
      </div>
    </div> 
  );
};

export default Navbar;
